// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionDivider_root__Naay6","divider":"SectionDivider_divider__2_o7h","noBottomMargin":"SectionDivider_noBottomMargin__cG9ZS"};